export default __webpack_public_path__ + "6a612b8c9740d2505b173af471fc396f.svg";